
import { Component, ElementRef, EventEmitter, input, Input, OnDestroy, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { cDataService } from 'src/app/services/data.service';
import * as CodeMirror from 'codemirror';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-structured-prompt',
  templateUrl: './structured-prompt.component.html',
  styleUrl: './structured-prompt.component.scss'
})
export class StructuredPromptComponent implements OnInit {
  selectedRowIndex: number = 0;
  @Output() closeModal = new EventEmitter<MouseEvent>();
  @Output() isAnyChange = new EventEmitter<any>();
  structuredPrompt: any
  selectedPromptRowIndex: any = 0;
  editingValue: string;
  editingKey: string = '';
  hoveredRowIndex: number = -1;
  modalRef!: NgbModalRef;
  @ViewChild('jsonEditorModal') jsonEditorModal!: ElementRef;
  jsonData: any;
  checkeditorSpecs: any;
  selectedItem: any;
  updateChildKey: boolean = false;
  formGroup: FormGroup;
  private addSubNodeHandler = () => this.addsubNode();
  codemirrorEditors: CodeMirror.EditorFromTextArea[] = [];
  currentIndex = 0;
  isEditingKey: boolean = false;
  editedKey: string = '';
  parentNode: boolean = false;
  @Output() savePayload = new EventEmitter<any>();
  showActions = true;
  constructor(
    private oDataService: cDataService,
    private modalService: NgbModal

  ) {
  }
  truncateText: number = 205;
  bResponseAlert: boolean;
  resMessage: { message: any; responseType: any; color: any };
  bLoading: boolean = true;
  hoveredChild: any = null;
  activityResponse: any
  @Input() prompt

  @Input() saveAPiCalled
  codeMirrorOptions: any = {
    mode: "application/json",
    indentWithTabs: true,
    smartIndent: true,
    lineNumbers: true,
    lineWrapping: true,
    extraKeys: { "Ctrl-Space": "autocomplete", "Ctrl-Q": function (cm) { cm.foldCode(cm.getCursor()); } },
    foldGutter: true,
    gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter", "CodeMirror-lint-markers"],
    autoCloseBrackets: true,
    matchBrackets: true,
    lint: true,
    autoFocus: true,
    theme: 'idea'
  };
  promptsList: any = []
  json: any
  parentItem: any;
  formData: any;
  @ViewChild('formContainer') formContainer!: ElementRef;
  @ViewChild('codemirror', { static: false }) codemirror: any;
  @ViewChildren('resizableTextarea') resizableTextareas: QueryList<ElementRef>;

  // ****************************************** ngOnInit ***************************************

  ngOnInit() {
    this.oDataService.activityResponse.subscribe(res => {
      this.activityResponse = res
      this.getPromptsList()
    })
  }

  onSplitResize(event) {
    const sidebarWidth = event.sizes[0];
    this.truncateText = sidebarWidth;
  }


  // --------------------getPromptsList  --------------------

  getPromptsList(action?: string, check?: boolean) {
    this.bLoading = false
    if (this.prompt) {
      this.promptsList = this.activityResponse.promptEditorSpecs;
    } else {
      this.promptsList = this.activityResponse.inputEditorSpecs;

    }
    if (this.promptsList && this.promptsList.length > 0 && this.promptsList[0].editor === "objectList") {
      this.promptsList[0].expand = true;
      if (this.promptsList[0].children && this.promptsList[0].children.length > 0) {
        let index = localStorage.getItem('selectedPromptIndex');
        this.selectedPromptRowIndex = index ?? '0-0';
        if (!this.selectedPromptRowIndex?.toString().includes('-')) {
          this.selectedPromptRowIndex = '0-0';
        }
        this.setActivePromptByNestedIndex(this.selectedPromptRowIndex);
        return;
      }
    }

    else if (!this.selectedPromptRowIndex?.toString().includes('-')) {
      this.selectedPromptRowIndex = 0
      this.setExtractedPropmtSetup(this.promptsList)
      this.setActivePromptByIndex(this.selectedPromptRowIndex);

    } else {
      this.selectedPromptRowIndex = 0
      this.setExtractedPropmtSetup(this.promptsList)
      this.setActivePromptByIndex(this.selectedPromptRowIndex);
      if (this.saveAPiCalled) this.selectedPromptRowIndex = 0
    }
   this.selectedPromptRowIndex?.toString().includes('-') ? this.updateChildKey=true :this.updateChildKey=false
  }
  setActivePromptByNestedIndex(index: string) {
    if (!index.includes('-')) {
      this.setActivePromptByIndex(parseInt(index));
      return;
    }
    const [parentIndexStr, childIndexStr] = index.split('-');
    const parentIndex = parseInt(parentIndexStr, 10);
    const childIndex = parseInt(childIndexStr, 10);
    this.selectedRowIndex = parentIndex;
    this.parentItem = this.promptsList[parentIndex];
    this.formData = this.promptsList[parentIndex].children[childIndex];
    this.selectedItem = this.promptsList[parentIndex].children[childIndex];

   this.selectedPromptRowIndex?.toString().includes('-') ? this.updateChildKey=true :this.updateChildKey=false

    setTimeout(() => {
      this.initializeResizeableTextareas();
    }, 200);
  }

  saveSelectedPromptToStorage(index: string | number): void {
    try {
      const storageKey = 'selectedPromptIndex';
      localStorage.setItem(storageKey, index.toString());
      console.log('Saved selection to localStorage:', index);
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
  }
  setExtractedPropmtSetup(prompt) {
    if (prompt) {
      this.checkeditorSpecs = prompt;
      this.selectedItem = prompt[this.selectedPromptRowIndex];
      this.structuredPrompt = prompt;
      setTimeout(() => {

        setTimeout(() => this.initializeResizeableTextareas());
      }, 200);
      this.formData = this.structuredPrompt[this.selectedPromptRowIndex];
    }

  }

  setActivePromptByIndex(index: number) {
    if (!this.promptsList || !this.promptsList[index]) {
      // console.warn('Invalid prompt index or promptsList is empty:', index);
      return;
    }

    this.selectedRowIndex = index;
    this.checkeditorSpecs = this.promptsList[this.selectedRowIndex];
    // this.selectedPromptRowIndex = 0;
    this.parentItem = this.promptsList[this.selectedRowIndex];
    if (Array.isArray(this.checkeditorSpecs) && this.checkeditorSpecs.length > 0) {
      this.formData = this.checkeditorSpecs[this.selectedPromptRowIndex];
    }
  }


  trackByIndex(index: number): number {
    return index;
  }

  // -------------------- Add/Remove Item in StringList --------------------

  addItem() {
    this.formData.value.push('');
    setTimeout(() => this.initializeResizeableTextareas());
  }

  removeItem(index: number): void {
    this.formData.value.splice(index, 1);
  }

  // -------------------- Text Area Resize --------------------

  initializeResizeableTextareas() {
    if (this.resizableTextareas) {
      this.resizableTextareas.forEach(textareaRef => {
        const textarea = textareaRef.nativeElement;
        this.adjustTextareaHeight(textarea);
        textarea.addEventListener('input', () => {
          this.adjustTextareaHeight(textarea);
        });
      });
    }
  }

  adjustTextareaHeight(textarea: HTMLTextAreaElement) {
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }



  getPromptData(item: any, index: any) {
    if (this.promptsList[index].editorSpecs && this.promptsList[index].content) {
      this.codeMirrorOptions.mode = 'application/ld+json'
    } else {
      this.codeMirrorOptions.mode = "plain/text"
    }

    setTimeout(() => {
      this.initializeResizeableTextareas();
    });
    this.selectedRowIndex = index;
    this.json = this.promptsList[this.selectedRowIndex]?.content
    this.checkeditorSpecs = item
    this.selectedPromptRowIndex = 0
    if (item.editorSpecs) {
      this.collapseAllNodes(item.editorSpecs);
      this.selectedItem = item.editorSpecs[0];
      this.structuredPrompt = item.editorSpecs;
      this.formData = item.editorSpecs[0];
    }


  }

  collapseAllNodes(nodes: any[]) {
    nodes.forEach(node => {
      node.expand = false;
    });
  }

  onClose() {
    this.closeModal.emit();
  }

  openVersionModal(version) {
    this.modalService.open(version, { centered: true, size: 'md', backdrop: 'static' });
  }

  // ****************************************** Structured prompt editor  ***************************************

  closeJsonModal() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }
  capitalizeFirstLetter(text: string): string {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  handleClick(child: any, index: string) {
    this.codeMirrorOptions.mode = 'application/ld+json'
    this.selectPromptItem(child, index, true, false);

  }

  // ********************************** Sidebar Node Selection  **********************************
  selectPromptItem(item: any, index: any, check: boolean, deletion: boolean) {
    let node;
    if (typeof index === 'string' && index.includes('-')) {
      const [parentIndex, childIndex] = index.split('-').map(Number);
      node = this.promptsList[parentIndex]?.children?.[childIndex];
    } else {
      node = this.promptsList[+index]; // convert to number in case it's a string
    }
    this.formData = node;
    setTimeout(() => {
      this.initializeResizeableTextareas();
    });
    const selectedIndexStr = this.selectedPromptRowIndex?.toString();
    if (!check && !deletion) {
      this.parentItem = item;

      this.promptsList[this.selectedPromptRowIndex] = this.selectedItem;
    }
    else if (selectedIndexStr?.includes('-') && check && !deletion) {
      let updatedData = JSON.parse(JSON.stringify(this.selectedItem))
      const [parentIndexStr, childIndexStr] = this.selectedPromptRowIndex.split('-');
      const parentIndex = parseInt(parentIndexStr, 10);
      const childIndex = parseInt(childIndexStr, 10);
      this.promptsList[parentIndex].children[childIndex] = updatedData;
    }
    item.expand = !item.expand;
    setTimeout(() => {
      this.updateChildKey = check;
      this.isEditingKey = false;
      this.selectedPromptRowIndex = index;
      this.selectedItem = item;
      setTimeout(() => {
        this.initializeResizeableTextareas();
      });
    }, 200);
    this.saveSelectedPromptToStorage(index);
  }

  addsubNode() {
    this.addDuplicateChild(this.selectedItem, this.selectedItem.children[this.selectedItem.children.length - 1], undefined, undefined)
    this.onDataChange()

  }

  // ***************************** Duplicate Node Creation  *******************************

  addDuplicateChild(parentItem: any, childItem: any, childIndex: number, event?: Event) {
    event?.stopPropagation();
    const duplicate = JSON.parse(JSON.stringify(childItem));
    const existingKeys = parentItem.children.map((c: any) => c.key);
    const baseKey = childItem.key.replace(/[0-9]*$/, '');
    let newKey = '';
    let counter = 1;
    do {
      newKey = `${baseKey}${counter}`;
      counter++;
    } while (existingKeys.includes(newKey));
    duplicate.key = newKey;
    if (childIndex != undefined) {
      parentItem.children.splice(childIndex + 1, 0, duplicate);
    }
    else {
      parentItem.children.push(duplicate);
    }
    this.updateStructuredPrompt(parentItem);
    this.onDataChange()

  }

  updateStructuredPrompt(updatedItem: any) {
    const index = this.structuredPrompt.findIndex(item => item.key === updatedItem.key);
    if (index !== -1) {
      this.structuredPrompt[index] = updatedItem;
    }
  }

  startEditingKey() {
    this.isEditingKey = true;
    this.editedKey = this.selectedItem?.key || '';
  }

  saveEditedKey() {
    const isDuplicate = this.parentItem.children
      .filter(child => child !== this.selectedItem)
      .some(child => child.key === this.editedKey);

    if (isDuplicate) {
      this.displayAlertMessage("Sub-Node name already exists.", 'danger', 'danger');
    } else {
      if (this.editedKey && this.selectedItem) {
        this.selectedItem.key = this.editedKey;
      }
      this.isEditingKey = false;
    }
  }

  // *************************** Remove Child Node  *********************
  removechild(event, parentItem, i, childIndex) {
    event?.stopPropagation();
    if (parentItem.children.length > 1) {
      parentItem.children.splice(childIndex, 1);
      const index = this.structuredPrompt.findIndex(item => item.key === parentItem.key);
      if (index !== -1) {
        this.structuredPrompt[index] = parentItem;
      }
      if (this.selectedPromptRowIndex === (i + '-' + childIndex)) {
        this.updateChildKey = false;
        this.selectPromptItem(parentItem, i, false, true);
        setTimeout(() => {
          this.selectPromptItem(parentItem, i, false, true);
        }, 100);
      }
    }
    this.onDataChange()

  }




  // ****************************************** ALERT MESSAGES ***************************************

  displayAlertMessage(
    sIncommingMessage,
    sIncommingResponseType,
    sIncommingColor
  ) {
    this.bResponseAlert = true;
    this.resMessage = {
      message: sIncommingMessage,
      responseType: sIncommingResponseType,
      color: sIncommingColor,
    };
    setTimeout(() => {
      this.bResponseAlert = false;
    }, 3000);
  }
  // *************************** Table Code  *********************

  insertRowAbove(index: number, tableData: any) {
    const newRow: any = {};
    tableData.columns.forEach((col: any) => {
      newRow[col.name] = '';
    });
    tableData.rows.splice(index, 0, newRow);
    this.onDataChange();
  }

  insertRowBelow(index: number, tableData: any) {
    const newRow: any = {};
    tableData.columns.forEach((col: any) => {
      newRow[col.name] = '';
    });
    tableData.rows.splice(index + 1, 0, newRow);
    this.onDataChange();
  }

  deleteRow(index: number, tableData: any) {
    tableData.rows.splice(index, 1);
    this.onDataChange();
  }

  onDataChange() {
    this.savePayload.emit(this.promptsList)
    this.isAnyChange.emit(true)
  }
  getIndentationWidth(level: number): number {
    // Start with base width and subtract more for deeper levels
    return this.truncateText - (100 + (level * 20));
  }


}
